import React from "react";

export const Image = ({ title, image }) => {
  return (
    <div className="portfolio-item">
      <div className="hover-bg">
          <div className="hover-text">
            <h4>{title}</h4>
          </div>
          <img src={image} alt={title} width="500" height="333"/>{" "}
      </div>
    </div>
  );
};
